<template>
  <section class="quick-quote-info">
    <div class="table">
      <div class="tr">
        <span>Plan Type</span>
        <span>{{ getAllOptionName23('plan_type', quoteForm.plan_type) }}</span>
      </div>
      <div class="tr">
        <span>Number of Adult </span>
        <span>{{ getAllOptionName23('adult_num', quoteForm.no_of_audit) }}</span>
      </div>
      <div class="tr">
        <span>Start Date </span>
        <span>{{ quoteForm.pcy_cmnt_dt }}</span>
      </div>
      <div class="tr">
        <span>Class Type</span>
        <span>{{ getAllOptionName23('class_type', quoteForm.class_type) }}</span>
      </div>
      <div class="tr">
        <span>Number of Children</span>
        <span>{{ getAllOptionName23('child_num', quoteForm.no_of_child) }}</span>
      </div>
      <div class="tr">
        <span>End Date </span>
        <span>{{ quoteForm.pcy_expry_dt }}</span>
      </div>
      <div class="tr">
        <span>
          <p>Confirm All Insurance Underwriting Questions?</p>
        </span>
        <span v-copy="getOptionName('answerList', quick_quote_detail.underwriting_confirm)">{{ getOptionName('answerList', quick_quote_detail.underwriting_confirm) }}</span>
      </div>
      <div
        v-if="benefits.length>0"
        class="tr">
        <span>Insured Items</span>
        <span>
          <span
            v-for="(item,index) in benefits"
            :key="'b'+index">
            {{item}}<br>
          </span>
        </span>
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'

export default {
  name: 'HousemaidQuickQuoteInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    quoteForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  },
  computed:{
    underwriting(){
      let {quick_quote_detail} = this.quoteForm||{}
      return quick_quote_detail.underwriting||[]
    },
    quick_quote_detail(){
      let {quick_quote_detail} = this.quoteForm||{}
      return quick_quote_detail||{}
    },
    benefits(){
      let {class_id,benefits=[]} = this.quoteForm||{}
      const benefitsList = benefits.reduce((result, item) => {
        result.push(
          this.getAllOptionName23('benefits', item)
        )
        return result
      }, [])
      return benefitsList
    }
  },
  created(){
  }
}
</script>
<style lang="scss" scoped>
</style>
